import React from 'react';

const MAP = {
  new: ['New', 'text-gold border-gold/40'],
  studio: ['In the studio', 'text-gold border-gold/40'],
  ready: ['Ready to listen', 'text-gold border-gold/40'],
  purchased: ['Purchased', 'text-emerald-400 border-emerald-500/40'],
};

export default function StatusBadge({ status }) {
  const [label, cls] = MAP[status] || MAP.new;
  return <span className={`flex items-center gap-2 text-[11px] font-mono tracking-widest uppercase border rounded-full px-3 py-1.5 ${cls}`}><span className="w-1.5 h-1.5 rounded-full bg-current animate-pulse" /> {label}</span>;
}
